import React, { useState, useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link, useLocation, useHistory } from 'react-router-dom';
import { RedMapPin, Bedrooms, Area } from '../../../assets/images/web-isn';
import previousIcon from '../../../assets/images/arrow-left.png';
import nextIcon from '../../../assets/images/arrow-right.png';
import ReactPaginate from 'react-paginate';
import { Flag } from '../../../assets/images/web-isn';
import { HeartIcon } from '../../../layouts/commons/icons';
import OwlCarousel from 'react-owl-carousel2';
import { ICON_LEFT, ICON_RIGHT } from '../../../utils/constants';
import { useTranslation } from 'react-i18next';
import { getPathLanguage, getQueryString } from '../../../utils/params';
import { LoginComponent } from '../../loginPage/pages';
import ForgotModal from '../../../modules/forgotPassword/pages/ForgotModal.component';
import { VerifyEmailComponent } from '../../signUp/pages';
import { formatMoney } from '../../../utils/objects';
import { getListOffersProject, getListTypeTerm } from '../detailApartment.api';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { BannerApartment, BreadcumbApartment, MenuApartment } from '../common';
import useFullPageLoader from '../../commons/isn/useFullPageLoader';
import { useParams } from 'react-router-dom';
import { getFavoriteApartment, postNewFavorite, postRemoveFavorite } from '../../serviceApartment/serviceApartment.api';
import { ContactUs } from '../../../modules/detailApartmentPage/pages';

const OffersComponent = props => {
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(useLocation().search);
  const { t } = useTranslation();
  const pathLanguage = getPathLanguage(useLocation());
  const { language, id} = useParams();
  const cityId = localStorage.getItem('LOCATION_CITY')
    ? localStorage.getItem('LOCATION_CITY')
    : localStorage.getItem('DEFAULT_CITY');
  const [pageSize, setPageSize] = useState(searchParams.get('pageSize'));
  const [pageIndex, setPageIndex] = useState(searchParams.get('pageIndex'));
  const [sortBy, setSortBy] = useState(searchParams.get('sortBy'));
  const [orderBy, setOrderBy] = useState(searchParams.get('orderBy'));
  const [pageCount, setPageCount] = useState();
  const [startItem, setStartItem] = useState(1);
  const [endItem, setEndItem] = useState(15);
  const [like, setLike] = useState([]);
  const [listServiced, setListServiced] = useState([]);
  const [showLogin, setShowLogin] = useState(false);
  const [showForgot, setShowForgot] = useState(false);
  const [showVerifyPopup, setShowVerifyPopup] = useState(false);
  const { currentCurrency } = props.layout;
  const [listTerm, setListTerm] = useState([]);
  const userInfo = useSelector(state => state.loginData.userInfo);
  const [showContact, setShowContact] = useState(false);
  const [commonId, setCommonId] = useState(null);

  //Owl carousel options
  const option = {
    items: 1,
    autoplay: false,
    loop: false,
    dots: true,
    nav: true,
    navText: [ICON_LEFT, ICON_RIGHT],
    autoHeight: true,
    responsive: {},
    animateOut: 'fadeOut',
    animateIn: 'fadeIn',
    center: true,
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    onFetchData()
    //eslint-disable-next-line
  }, [pageIndex, pageSize, cityId, sortBy, orderBy]);

  const onFetchData = () => {
    try{
      showLoader();
      getListOffersProject(
        getQueryString({ language, cityId, projectId: id, sortBy, orderBy, pageSize, pageIndex }),
      ).then(res => {
        if (res?.data) {
          setListServiced(res?.data);
          if (res?.data) {
            let changeEndItem = pageSize * pageIndex;
            if (changeEndItem > res?.data.totalRecords) {
              setEndItem(res?.data.totalRecords);
            } else {
              setEndItem(changeEndItem);
            }
          }
          setPageCount(Math.ceil(res?.data?.totalRecords / pageSize));
        }
      });
    }finally{
      hideLoader();
    }
  }
  // get favorite data

  useEffect(() => {
    setLike([]);
    const authUserData = JSON.parse(localStorage.getItem('authUserData'));
    if (authUserData) {
      onFetchDataFavorite({ language });
    }
    // eslint-disable-next-line
  }, [userInfo]);

  useEffect(() => {
    getListTypeTerm(getQueryString({ language })).then(res => {
      setListTerm(res?.data);
    });
    //eslint-disable-next-line
  }, [pageIndex, pageSize]);

  const onFetchDataFavorite = query => {
    showLoader();
    try {
      getFavoriteApartment(getQueryString(query)).then(res => {
        if (res?.data) {
          let data = res?.data?.map(el => {
            return el.apartmentId;
          });
          setLike(data);
        }
      });
    } finally {
      hideLoader();
    }
  };

  const getTypeSortBy = e => {
    setSortBy(e.target.value);
    setPageIndex(1);
    setForcePage(0);
    searchParams.set('sortBy', e.target.value);
    searchParams.set('pageIndex', 1);
    history.push({pathname: `${location.pathname}`, search: searchParams.toString()})
  };

  const getTypeOrderBy = e => {
    setOrderBy(e.target.value);
    setPageIndex(1);
    setForcePage(0);
    searchParams.set('orderBy', e.target.value);
    searchParams.set('pageIndex', 1);
    history.push({pathname: `${location.pathname}`, search: searchParams.toString()})
  };

  const handleLike = async (event, id) => {
    event.preventDefault();
    const authUserData = JSON.parse(localStorage.getItem('authUserData'));
    if (authUserData) {
      let listData = [];
      if (like && like.includes(id)) {
        let res = await postRemoveFavorite({ apartmentId: id });
        if (res?.data) {
          listData = like.filter(i => i !== id);
          setLike(listData);
        }
      } else {
        let res = await postNewFavorite({ apartmentId: id });
        if (res?.data) {
          listData = [...like, id];
          setLike(listData);
        }
      }
    } else {
      handleShowLogin();
    }
  };
  // Go to detail page
  const goToDetailPage = data => {
    history.push(`${pathLanguage}/serviced-apartments/overview/${data.id}/${data.slug}/${data.typeCode}`);
  };

  // Change pageSize
  const [forcePage, setForcePage] = useState(searchParams.get('pageIndex') - 1);
  const handlePageSize = e => {
    let pageSize = e.target.value;
    let newPageSize = parseInt(pageSize);
    setPageSize(newPageSize);
    setForcePage(0);
    searchParams.set('pageSize', newPageSize);
    searchParams.set('pageIndex', 1);
    history.push({pathname: location.pathname, search: searchParams.toString()})
  };

  const changePage = ({ selected }) => {
    setForcePage(selected);
    setPageIndex(selected + 1);
    setStartItem(pageSize * selected + 1);
    window.scrollTo({ top: 335, behavior: 'smooth' });
    window.scrollTo({ top: 335, behavior: 'smooth' });
    searchParams.set('pageIndex', selected + 1);
    history.push({pathname: location.pathname, search: searchParams.toString()})
  };

  const handleShowLogin = () => {
    setShowLogin(true);
    setShowForgot(false);
  };

  const handleShowForgot = () => {
    setShowLogin(false);
    setShowForgot(true);
  };

  const handleShowSignUp = () => {
    setShowLogin(false);
    setShowVerifyPopup(true);
  };

  const gotoPreparePage = (item) => {
    setShowContact(true)
    setCommonId(item.id ?? null)
  };

  const handleButtonBook = item => {
    const authUserData = JSON.parse(localStorage.getItem('authUserData'));
    if (authUserData) {
      history.push(`/${language}/payment-summary/${item.apartmentId}`);
    } else {
      handleShowLogin();
    }
  };

  const closeVerifyEmailPopup = () => {
    setShowVerifyPopup(false);
  };
  const displayItems = () => {
    if (listServiced && listServiced.items) {
      const listServiceApartment = listServiced.items;
      return (
        <div className="serviceapartment-page row mt-2">
          {listServiceApartment.map((item, index) => {
            return (
              <div id="listOffers" className="service-cover col-12 col-md-6" key={index}>
                <div className="project-info justify-content-center align-items-center mt-3">
                  <div className="container-slider">
                    <OwlCarousel options={option}>
                      {item.images.map((sliderImage, i) => {
                        return (
                          <div className="slide" key={i}>
                            <Link
                              to={`${pathLanguage}/serviced-apartments/overview/${item.id}/${item.slug}/${item.typeCode}`}
                            >
                              <LazyLoadImage
                                src={`${process.env.REACT_APP_ISN_IMAGE_URL}${sliderImage.url}`}
                                alt={item.name}
                              />
                            </Link>
                          </div>
                        );
                      })}
                    </OwlCarousel>
                  </div>
                  <div
                    onClick={e => handleLike(e, item.apartmentId)}
                    className={like.includes(item.apartmentId) ? 'like-contents active' : 'like-contents'}
                  >
                    <HeartIcon />
                  </div>
                  <div className="project-card">
                    <div className="content">
                      <div onClick={() => goToDetailPage(item)} className="project-name text-truncate-box-title-name ml-1">{item.name}</div>
                      {item.address ? (
                        <div className="mt-2 mt-lg-4">
                          <div className="d-flex align-items-center">
                            <img src={Flag} alt="location" />
                            <div className="project-location text-truncate-box-title-name mr-3">{item.address}</div>
                          </div>
                        </div>
                      ) : (
                        ''
                      )}
                      <div className="apartment-infomation d-flex mt-3 flex-column">
                        <div onClick={() => goToDetailPage(item)}  className="d-flex justify-content-between">
                          <div className="d-flex">
                            <img src={RedMapPin} alt="location" />
                            <div className="project-location mr-3">{item.district}</div>
                          </div>
                          <div className="bedroom-size d-flex">
                            <img src={Bedrooms} alt="bedrooms" />
                            <div className="project-bed">
                              {item.bedRoomName ? <span>&nbsp;{item.bedRoomName}</span> : ''}
                              &nbsp;
                            </div>
                          </div>
                        </div>
                        <div onClick={() => goToDetailPage(item)} className="d-flex justify-content-between align-items-start">
                          <div className="mt-2 d-flex">
                            <div className="project-price">
                              <span className="focus-price">
                                {currentCurrency?.code === 'USD' && item.priceOffer && item.isOffer === true
                                  ? `${currentCurrency?.symbol}${formatMoney(item.priceOffer, 0, 0)}`
                                  : ''}
                                {currentCurrency?.code === 'USD' &&
                                item.price &&
                                (item.isOffer === false || (item.isOffer && !item.priceOffer))
                                  ? `${currentCurrency?.symbol}${formatMoney(item.price, 0, 0)}`
                                  : ''}
                                {currentCurrency?.code === 'VND' && item.priceOfferVi && item.isOffer === true
                                  ? `${formatMoney(item.priceOfferVi, 0, 0)}${currentCurrency?.symbol}`
                                  : ''}
                                {currentCurrency?.code === 'VND' &&
                                item.priceVi &&
                                (item.isOffer === false || (item.isOffer && !item.priceOfferVi))
                                  ? `${formatMoney(item.priceVi, 0, 0)}${currentCurrency?.symbol}`
                                  : ''}
                              </span>
                              /
                              {item.typeCode === 'long' ? (
                                <span>{t('service_apartment_isn.label_month')}</span>
                              ) : (
                                <span>{t('service_apartment_isn.label_day')}</span>
                              )}
                            </div>
                            {item.priceOffer > 0 && item.priceOfferVi > 0 && (
                              <div className="project-price pl-2" style={{ color: '#6b6b6b' }}>
                                <span className="focus-price" style={{ textDecoration: 'line-through' }}>
                                  {currentCurrency?.code === 'USD' && item.isOffer === true && item.priceOffer > 0
                                    ? `${currentCurrency?.symbol}${formatMoney(item.price, 0, 0)}`
                                    : ''}
                                  {currentCurrency?.code === 'VND' && item.isOffer === true && item.priceOfferVi > 0
                                    ? `${formatMoney(item.priceVi, 0, 0)}${currentCurrency?.symbol}`
                                    : ''}
                                </span>
                                {item.typeCode === 'long' && item.priceOffer > 0 && item.priceOfferVi > 0 ? (
                                  <span style={{ textDecoration: 'line-through' }}>/{t('offers.label_month')}</span>
                                ) : (
                                  ''
                                )}
                                {item.typeCode === 'short' && item.priceOffer > 0 && item.priceOfferVi > 0 ? (
                                  <span style={{ textDecoration: 'line-through' }}>/{t('offers.label_day')}</span>
                                ) : (
                                  ''
                                )}
                              </div>
                            )}
                          </div>
                          <div className="d-flex align-items-center mt-2">
                            <img src={Area} alt="area" />
                            <div className="project-area">
                              {item.size ? `${item.size}` : ''}
                                m<sup>2</sup>
                            </div>
                          </div>
                        </div>
                        <div className="d-flex justify-content-between extra-btn mt-3">
                          <button onClick={() => goToDetailPage(item)} className="block-button details-block-btn mr-3">{t('offers.btn_details')}</button>
                          {item.typeCode === 'short' ? (
                            <button onClick={() => handleButtonBook(item)} className="block-button booknow-block-btn">{t('offers.btn_booknow')}</button>
                          ) : (
                            ''
                          )}
                          {item.typeCode === 'long' ? (
                            <button onClick={() => gotoPreparePage(item)} className="block-button booknow-block-btn">{t('offers.btn_contactus')}</button>
                          ) : (
                            ''
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {item.offerItems && item.offerItems.length > 0 ? (
                  <div className="special-offers">
                    <div className="d-flex">
                      <div className="rectangle"></div>
                      <div className="triangle-right"></div>
                    </div>
                    <span className="text">{t('label_special_offers')}</span>
                  </div>
                ) : (
                  ''
                )}
              </div>
            );
          })}
        </div>
      );
    }
  };
  return (
    <React.Fragment>
      <BreadcumbApartment />
      <BannerApartment />
      <MenuApartment />
      <ContactUs
        commonId={commonId}
        showLogin={showContact}
        closeLogin={() => {
          setShowContact(false);
        }}
      />
      <div id="listOffers">
        <div className="container mt-5">
          <div className="item-per-page-container">
            <span className="text-sort mr-3">{t('offers.text_sort_by')}</span>
            <select className="item-sort" onChange={e => getTypeSortBy(e)}>
              {listTerm && listTerm.length > 0
                ? listTerm.map((item, i) => {
                    return (
                      <option key={i} value={item.id} defaultValue={sortBy === `${item.id}`}>
                        {t('offers.text_term')}: {item.name}
                      </option>
                    );
                  })
                : ''}
            </select>
            <span className="divided-line">&nbsp;</span>
            <select className="item-sort" onChange={e => getTypeOrderBy(e)} value={orderBy}>
              <option value="asc">
                {t('offers.text_price')}: {t('offers.text_sort_asc')}
              </option>
              <option value="desc">
                {t('offers.text_price')}: {t('offers.text_sort_des')}
              </option>
            </select>
            {/* display total item, item count of current page */}
            {listServiced ? (
              <div className="item-count-container">
                <span className="divided-line">&nbsp;</span>{' '}
                {listServiced.totalRecords !== startItem ? `${startItem} - ` : ''}
                {listServiced.totalRecords > listServiced.pageSize ? endItem : listServiced.totalRecords}{' '}
                {t('offers.text_of')} {listServiced.totalRecords} <span>&nbsp;</span>
              </div>
            ) : (
              ''
            )}
            {/* select items display per page */}
            <select className="item-number" onChange={e => handlePageSize(e)} value={pageSize}>
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="30">30</option>
              <option value="40">40</option>
              <option value="50">50</option>
              <option value="60">60</option>
            </select>
          </div>
        </div>

        {/* render apartments list */}
        <div className="container">{displayItems()}</div>

        {/* paginate */}
        {listServiced && listServiced.totalRecords > 10 ? (
          <div className="service-paginate">
            <ReactPaginate
              previousLabel={<LazyLoadImage src={previousIcon} alt="nav-btn" />}
              nextLabel={<LazyLoadImage src={nextIcon} alt="nav-btn" />}
              pageRangeDisplayed={1}
              marginPagesDisplayed={2}
              pageCount={pageCount}
              onPageChange={changePage}
              disabledClassName={'opacity-disable'}
              activeClassName={'pagination-active'}
              pageClassName={'pagination-pager-item'}
              nextLinkClassName={'next-btn'}
              previousLinkClassName={'prev-btn'}
              forcePage={forcePage}
            />
          </div>
        ) : (
          <div className="mt-5"></div>
        )}
        <LoginComponent
          closeLogin={() => {
            setShowLogin(false);
          }}
          showLogin={showLogin}
          handleShowForgot={handleShowForgot}
          handleShowSignUp={handleShowSignUp}
        />
        <VerifyEmailComponent
          showVerifyEmail={showVerifyPopup}
          hideVerifyEmail={closeVerifyEmailPopup}
        ></VerifyEmailComponent>
        <ForgotModal showModal={showForgot} hideModal={() => setShowForgot(false)} handleShowLogin={handleShowLogin} />
      </div>
      {loader}
    </React.Fragment>
  );
};

const mapStatetoProps = state => ({
  ...state,
});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default connect(mapStatetoProps, mapDispatchToProps)(OffersComponent);
